export const GET_REPORT_ACTION_FAILED = "GET_REPORT_ACTION_FAILED";
export const GET_REPORT_ACTION_SUCCESS = "GET_REPORT_ACTION_SUCCESS";
export const GENERATE_REPORT_IN_PROGRESS = "GENERATE_REPORT_IN_PROGRESS";
export const GET_SUBSCRIPTION_DETAILS_SUCCESS =
  "GET_SUBSCRIPTION_DETAILS_SUCCESS";
